import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {environment} from "../environments/environment";
import { ISubscriptionModel } from "../models/subscription.model";
@Injectable({
    providedIn: 'root'
  })

  export class SubscriptionService{
    constructor(private http: HttpClient){}

    // http://localhost:8080/api
    allPostAbonnementForUser(): Observable<any>{
        let headers = new HttpHeaders();
        headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
      return this.http.get(`${environment.url}/subscribe?page=0&size=32`,{'headers': headers});
    }

    allPostAbonnement(page: number, size: number): Observable<any>{
        let headers = new HttpHeaders();
        headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
      return this.http.get(`${environment.url}/subscribe/all?page=${page}&size=${size}`,{'headers': headers});
    }

    allPostPassAbonnement(page: number, size: number): Observable<any>{
      let headers = new HttpHeaders();
      headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/subscribe/all_pass?page=${page}&size=${size}`,{'headers': headers});
  }
  allPostForfaitAbonnement(page: number, size: number): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
  return this.http.get(`${environment.url}/subscribe/all_forfait?page=${page}&size=${size}`,{'headers': headers});
}

    getSubscribeFilter(startDate: any, endDate: any ,page: number, size: number): Observable<any> {
      let headers = new HttpHeaders();
      headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
      return this.http.get(`${environment.url}/subscribe/all?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
    }

    allPostAbonnements_1(): Observable<any>{
      let headers = new HttpHeaders();
      return this.http.get(`${environment.url}/v1/posts/pass?fields=postServiceModels,postPromotions,postSubProducts,subProductCharacteristics,characteristic&page=0&size=32`,{'headers': headers});
    }

    getByIdSubscribe(id: number) {
        let headers = new HttpHeaders();
        headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
        return this.http.get(`${environment.url}/subscribe/` + id, {'headers': headers});
    }

 
    deleteAbonnement(subscribe:ISubscriptionModel){
      let headers = new HttpHeaders();
      headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
      return this.http.delete(`${environment.url}/subscribe/`+subscribe.id,{'headers': headers});
    }
    
  }

